<template>
  <div id="media">
    <div class="slide-media">
      <div class="slideContent" v-html="makeIframe(url).content"></div>
    </div>
  </div>
</template>

<script>
import linkVal from "@/assets/js/linkValidation";

export default {
  props: ["url"],
  methods: {
    makeIframe(link) {
      let yt = linkVal.isYoutube(link);
      let insta = linkVal.isInstagram(link);
      let soundcloud = linkVal.isSoundcloud(link);
      if (yt)
        return {
          content: `<iframe id="${yt}" width="650" height="400" src="https://www.youtube.com/embed/${yt}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope" allowfullscreen></iframe>`
        };
      else if (soundcloud)
        return {
          content: `<iframe id="sc-widget" width="650" height="175" src="https://w.soundcloud.com/player/?url=${soundcloud}" scrolling="no" frameborder="no"></iframe>`
        };
      else if (insta) {
        return {
          content: `<iframe id="insta" width="320" height="400" src="https://instagram.com/p/${insta}/embed/" scrolling="no" frameborder="no" allowtransparency="true"></iframe>`
        };
      }
      else
        return {
          content: `<iframe style="width:400px; height:400px; object-fit: contain;" src="${link}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`
        };
    }
  }
};
</script>

<style scoped>
body {
  background: #f5f1ed;
  font-family: Roboto, sans-serif;
  margin: 0;
}
#media {
  padding: 15px;
  /* max-width: 600px;
    max-height: 400px; */
}
.slide-media {
  /* background: #464646; */
  /* min-width: 600px; */
  /* max-width: 600px; */
  /* min-height: 60vh; */
  /* max-height: 700px; */
  /* padding: 50px; */
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  align-items: center;
  /* object-fit: cover; */
}
.slide .slideContent {
  text-align: center;
  /* background-color: #5a5a5a; */
}
.slide-nav {
  /* position: absolute; */
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  /* height: 100vh; */
}
.left-media,
.right-media {
  font-size: 75px;
  width: 24px;
  height: 24px;
  padding: 18px;
  cursor: pointer;
}
.md-icon.md-theme-default.md-icon-font {
  color: #1b73a2;
  /* height: 4.2em; */
  height: 60vh;
}
.disable-change {
  color: #aaaaaa !important;
}
.prev-slide-media {
  position: relative;
  float: left;
  /* top: 10em; */
}
.next-slide-media {
  position: relative;
  float: right;
  /* top: 10em; */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
